import gsap from 'gsap';

export const fadeInPreloader = (el, { duration = 1, onComplete } = {}) => {
  return gsap.to(el, {
    duration,
    autoAlpha: 1,
    overwrite: 'auto',
    onComplete
  });
};

export const fadeOutPreloader = (el, { duration = 0.5, onStart, onComplete } = {}) => {
  return gsap.to(el, {
    duration,
    autoAlpha: 0,
    overwrite: 'auto',
    onStart,
    onComplete
  });
};
